import * as react from "react";
import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../../../fable_modules/Fable.React.9.4.0/./Fable.React.FunctionComponent.fs.js";
import { value as value_1 } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { int32ToString } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { empty as empty_1, map, ofArray, singleton as singleton_1, isEmpty, exists } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { indexed, collect, empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.4.19.0/Seq.js";
import { DangerousHtml, Prop, DOMAttr, HTMLAttr } from "../../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { validatedTextarea, validatedTextBox, errorMsg, spinner, linkicon, newIndicator } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";
import { asString } from "../../../../Bfs.Web.Data.Service.Contracts/Shared.fs.js";
import { Model__get_CanSubmit, Msg, ticketStatus } from "./Types.fs.js";
import { CollapsableElement } from "../../../../Bfs.Web.Portale/Collapsable.fs.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { Tab_Option, tab, Option, tabs } from "../../../fable_modules/Fulma.3.0.0/Components/Tabs.fs.js";
import { Accept, UploadFileType_Image, UploadFileType_Pdf, UploadBox } from "../../../../Bfs.Web.Portale/UploadBox.fs.js";
import { printf, toText } from "../../../fable_modules/fable-library-js.4.19.0/String.js";
import { div } from "../../../fable_modules/Fulma.3.0.0/Elements/Form/Field.fs.js";
import { Option as Option_1, div as div_1 } from "../../../fable_modules/Fulma.3.0.0/Elements/Form/Control.fs.js";
import { DropdownProps$1, bfsDropdown } from "../Shared/Dropdown.fs.js";
import { Help_sizeLimitMB } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { Option as Option_2, ISize, column } from "../../../fable_modules/Fulma.3.0.0/Layouts/Column.fs.js";
import { Screen } from "../../../fable_modules/Fulma.3.0.0/Common.fs.js";

export const ticketInfoBox = (() => {
    let children_6, children_4, children;
    const children_8 = [(children_6 = [(children_4 = [(children = [react.createElement("img", {
        src: "help/bfs_ticketsystem_4.png",
    })], react.createElement("div", {
        className: "image-wrapper",
    }, ...children)), react.createElement("div", {
        className: "username has-text-centered",
    }, "Erstellen Sie hier ein Ticket an unseren Kundenservice.")], react.createElement("div", {
        className: "card-body",
    }, ...children_4))], react.createElement("div", {
        className: "flat-card upload-card is-auto",
    }, ...children_6))];
    return react.createElement("div", {
        className: "is-relative is-hidden-touch",
    }, ...children_8);
})();

export function ticketRow(onExpand) {
    return FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value_1("C:\\BuildAgent\\work\\c238671ccc1e7da2\\BfsKundenportal\\src\\Bfs.Web.Kundenportal\\WebParts\\User\\Tickets\\View.fs") + "#L") + int32ToString(value_1(34))) + ";") + "System.Tuple`3[Bfs.Web.Data.Service.Contracts.Kundenportal.Help.UserTicketListItem,System.Boolean,Fable.React.IRefValue`1[Microsoft.FSharp.Core.FSharpOption`1[Browser.Types.Element]]]", value_1("ticketRow"), (tupledArg) => {
        const ticket = tupledArg[0];
        const isSelected = tupledArg[1];
        const isExpanded = react.useState(isSelected);
        const chevronClass = (isExpanded[0]) ? "upsidedown" : "";
        if (isSelected && exists((_arg) => _arg.IsNew, ticket.Antworten)) {
            onExpand(ticket.TicketId);
        }
        const children_46 = toList(delay(() => {
            let props_18, children_18, children, children_2, children_10, children_14, children_16;
            return append(singleton((props_18 = toList(delay(() => append(singleton(new HTMLAttr(65, ["has-additional-data-row"])), delay(() => append(singleton(new DOMAttr(40, [(_arg_1) => {
                const newIsExpanded = !(isExpanded[0]);
                isExpanded[1](newIsExpanded);
                if (newIsExpanded && exists((_arg_2) => _arg_2.IsNew, ticket.Antworten)) {
                    onExpand(ticket.TicketId);
                }
            }])), delay(() => (isSelected ? singleton(new Prop(3, [tupledArg[2]])) : empty()))))))), (children_18 = [(children = toList(delay(() => append((!(isExpanded[0]) && exists((_arg_3) => _arg_3.IsNew, ticket.Antworten)) ? singleton(newIndicator) : empty(), delay(() => singleton(asString(ticket.Datum)))))), react.createElement("td", {}, ...children)), (children_2 = toList(delay(() => {
                const matchValue = ticket.Nummer;
                const matchValue_1 = ticket.AbsetzungImportNummer;
                const matchValue_2 = ticket.AufgabeNummer;
                return (matchValue != null) ? singleton(`#${matchValue}`) : ((matchValue_1 != null) ? singleton(`A-${matchValue_1}`) : ((matchValue_2 != null) ? singleton(`${matchValue_2}`) : singleton("")));
            })), react.createElement("td", {
                className: "nowrap",
            }, ...children_2)), (children_10 = toList(delay(() => {
                let children_6;
                const iconclass = ticket.IstErledigt ? (isEmpty(ticket.Antworten) ? "fas fa-check-square" : "fas fa-envelope-open-text") : "fas fa-business-time";
                return append(singleton((children_6 = [react.createElement("i", {
                    className: iconclass,
                })], react.createElement("span", {
                    className: "icon",
                }, ...children_6))), delay(() => {
                    let children_8;
                    return singleton((children_8 = [ticketStatus(ticket)], react.createElement("span", {
                        className: "is-hidden-mobile",
                    }, ...children_8)));
                }));
            })), react.createElement("td", {
                className: "nowrap",
            }, ...children_10)), (children_14 = toList(delay(() => {
                let props_12;
                return singleton(CollapsableElement([(props_12 = [["style", {
                    whiteSpace: "pre-wrap",
                }]], react.createElement("div", keyValueList(props_12, 1), ticket.Betreff)), isExpanded[0]]));
            })), react.createElement("td", {
                className: "is-hidden-mobile ticket-title",
            }, ...children_14)), (children_16 = [linkicon(`fas fa-chevron-down ${chevronClass}`)], react.createElement("td", {}, ...children_16))], react.createElement("tr", keyValueList(props_18, 1), ...children_18)))), delay(() => {
                let children_32, children_30;
                return append(singleton((children_32 = [(children_30 = toList(delay(() => {
                    let children_28;
                    return singleton(CollapsableElement([(children_28 = toList(delay(() => {
                        let children_22;
                        return append(singleton((children_22 = [react.createElement("b", {}, ticket.Betreff)], react.createElement("div", {
                            className: "is-hidden-tablet",
                        }, ...children_22))), delay(() => {
                            let props_24;
                            return append(singleton((props_24 = [["style", {
                                whiteSpace: "pre-wrap",
                            }]], react.createElement("div", keyValueList(props_24, 1), ticket.Text))), delay(() => {
                                let children_26;
                                return (ticket.Attachments != null) ? singleton((children_26 = [`Anhänge: ${value_1(ticket.Attachments)}`], react.createElement("div", {}, ...children_26))) : empty();
                            }));
                        }));
                    })), react.createElement("div", {
                        className: "ticket-body",
                    }, ...children_28)), isExpanded[0]]));
                })), react.createElement("td", {
                    colSpan: 5,
                }, ...children_30))], react.createElement("tr", {
                    className: "additional-data",
                }, ...children_32))), delay(() => (!isEmpty(ticket.Antworten) ? singleton(Array.from(delay(() => collect((matchValue_7) => {
                    let children_44, children_42;
                    const antwort = matchValue_7[1];
                    const isFirst = matchValue_7[0] === 0;
                    return singleton((children_44 = [(children_42 = toList(delay(() => {
                        let children_40, children_38;
                        return singleton(CollapsableElement([(children_40 = [(children_38 = toList(delay(() => append(isFirst ? append(singleton(react.createElement("br", {})), delay(() => append(singleton(react.createElement("b", {}, "Antwort BFS:")), delay(() => singleton(react.createElement("br", {})))))) : empty(), delay(() => append(antwort.IsNew ? singleton(newIndicator) : empty(), delay(() => {
                            let props_40;
                            return singleton((props_40 = [new DOMAttr(0, [new DangerousHtml(antwort.Text)])], react.createElement("p", keyValueList(props_40, 1))));
                        })))))), react.createElement("div", {}, ...children_38))], react.createElement("div", {
                            className: "ticket-body",
                        }, ...children_40)), isExpanded[0]]));
                    })), react.createElement("td", {
                        colSpan: 5,
                    }, ...children_42))], react.createElement("tr", {
                        className: "additional-data",
                    }, ...children_44)));
                }, indexed(ticket.Antworten))))) : empty())));
            }));
        }));
        return react.createElement(react.Fragment, {}, ...children_46);
    }, undefined, undefined, "Of");
}

export function ticketTable(model, dispatch, showTicketRef) {
    let children_26, children_4, children_24;
    const children_28 = [(children_26 = [(children_4 = [tabs(singleton_1(new Option(7, ["account-tabs"])), [tab(ofArray([new Tab_Option(1, ["submenu-item"]), new Tab_Option(0, [model.ShowOnlyMyTickets])]), singleton_1(react.createElement("a", {
        onClick: (_arg) => {
            dispatch(new Msg(0, [true]));
        },
    }, "Meine Tickets"))), tab(ofArray([new Tab_Option(1, ["submenu-item"]), new Tab_Option(0, [!model.ShowOnlyMyTickets])]), singleton_1(react.createElement("a", {
        onClick: (_arg_1) => {
            dispatch(new Msg(0, [false]));
        },
    }, "Alle Tickets")))])], react.createElement("div", {
        className: "card-title-with-tabs",
    }, ...children_4)), (children_24 = toList(delay(() => {
        let children_22, children_18, children_16, children_20;
        const matchValue = model.UserTickets;
        return (matchValue.tag === 3) ? (isEmpty(matchValue.fields[0]) ? singleton("Keine Tickets vorhanden") : singleton((children_22 = [(children_18 = [(children_16 = [react.createElement("th", {}, "Datum"), react.createElement("th", {}, "Ticket"), react.createElement("th", {}, "Status"), react.createElement("th", {
            className: "is-hidden-mobile",
        }, "Betreff"), react.createElement("th", {})], react.createElement("tr", {}, ...children_16))], react.createElement("thead", {}, ...children_18)), (children_20 = map((ticket) => {
            const isSelected = (model.TicketToShow != null) && (value_1(model.TicketToShow) === ticket.TicketId);
            return ticketRow((id) => {
                dispatch(new Msg(10, [id]));
            })([ticket, isSelected, showTicketRef]);
        }, matchValue.fields[0]), react.createElement("tbody", {}, ...children_20))], react.createElement("table", {
            className: "table table-striped responsive-table ",
        }, ...children_22)))) : ((matchValue.tag === 1) ? singleton(spinner) : ((matchValue.tag === 2) ? singleton(errorMsg(matchValue.fields[0])) : singleton("Keine Tickets vorhanden")));
    })), react.createElement("div", {
        className: "card-body",
    }, ...children_24))], react.createElement("div", {
        className: "flat-card profile-info-card is-auto",
    }, ...children_26))];
    return react.createElement("div", {}, ...children_28);
}

export function ticketUploadBox(model, dispatch) {
    return UploadBox([new Accept(1, [ofArray([UploadFileType_Pdf, UploadFileType_Image])]), (filelist) => {
        dispatch(new Msg(6, [filelist]));
    }, (file) => {
        dispatch(new Msg(8, [file]));
    }, model.CurrentUploadList, model.CurrentUploadCount, undefined, (msg) => {
        dispatch(new Msg(15, [msg]));
    }]);
}

export function form(model, dispatch) {
    let children, children_10, children_2, children_8, children_18, children_12, children_16, children_22, props_20;
    const isLoading = model.Sending ? " is-loading" : "";
    const children_24 = [(children = [toText(printf("Hier können Sie als %s ein neues Ticket anlegen. Eine Rückmeldung erhalten Sie von uns per E-Mail. Wir werden Sie unter der E-Mail-Adresse %s kontaktieren."))(model.Name)(model.Mail)], react.createElement("p", {}, ...children)), (children_10 = [(children_2 = [validatedTextBox((arg_2) => {
        dispatch(new Msg(2, [arg_2]));
    })("Betreff:")("Betreff")("Bitte geben Sie einen Betreff ein")(model.Betreff)], react.createElement("div", {
        className: "column is-half",
    }, ...children_2)), (children_8 = [div(empty_1(), ofArray([react.createElement("label", {
        className: "label",
    }, "Kategorie:"), div_1(singleton_1(new Option_1(3, [])), toList(delay(() => append(singleton(bfsDropdown()(new DropdownProps$1(model.KundenportalTicketKategorien, model.SelectedKundenportalTicketKategorie, (k_1) => k_1.Bezeichnung, (k) => int32ToString(k.Id), (category) => {
        dispatch(new Msg(14, [category]));
    }))), delay(() => {
        const matchValue = model.SelectedKundenportalTicketKategorieFormField.Error;
        if (matchValue != null) {
            const error = matchValue;
            return singleton(react.createElement("span", {
                className: "help is-danger",
            }, error));
        }
        else {
            return empty();
        }
    })))))]))], react.createElement("div", {
        className: "column is-half",
    }, ...children_8))], react.createElement("div", {
        className: "columns",
    }, ...children_10)), (children_18 = [(children_12 = [validatedTextarea((arg_3) => {
        dispatch(new Msg(3, [arg_3]));
    }, "Ihre Nachricht:", "Text", "Bitte schildern Sie hier genau Ihren Sachverhalt. Alle Details und Informationen helfen unserem Kundenservice-Team bei der Recherche und Lösung Ihres Anliegens.", "is-big", model.Text)], react.createElement("div", {
        className: "column is-two-third",
    }, ...children_12)), (children_16 = [react.createElement("label", {
        className: "label",
    }, "Ihre Dateianhänge:"), ticketUploadBox(model, dispatch)], react.createElement("div", {
        className: "column is-one-third field",
    }, ...children_16))], react.createElement("div", {
        className: "columns",
    }, ...children_18)), (children_22 = [(props_20 = [new HTMLAttr(65, ["bfsbutton wide " + isLoading]), new HTMLAttr(79, [!Model__get_CanSubmit(model)]), new DOMAttr(40, [(_arg) => {
        dispatch(new Msg(4, []));
    }])], react.createElement("button", keyValueList(props_20, 1), "Absenden"))], react.createElement("p", {
        className: "is-pulled-right",
    }, ...children_22))];
    return react.createElement("div", {
        className: "paragraphs datenuebergabe",
    }, ...children_24);
}

export function showMsg(result) {
    let children_10, children_8, s_3, children_18, children_2, s_1;
    switch (result.tag) {
        case 1: {
            const children_14 = [(children_10 = [(children_8 = [(s_3 = "Das Limit der erstellen Tickets wurde erreicht. In wenigen Augenblicken können Sie uns jedoch weitere Tickets senden.", s_3)], react.createElement("b", {}, ...children_8))], react.createElement("p", {
                className: "error-msg",
            }, ...children_10)), react.createElement("p", {}, "Vielen Dank für Ihr Verständnis.")];
            return react.createElement("div", {
                className: "paragraphs",
            }, ...children_14);
        }
        case 2: {
            const children_24 = [(children_18 = [react.createElement("b", {}, `Leider haben Sie das Limit von ${Help_sizeLimitMB} MB Anhängen pro Ticket überschritten und Ihr Ticket wurde nicht versendet.`)], react.createElement("p", {
                className: "error-msg",
            }, ...children_18)), react.createElement("p", {}, "Bitte reduzieren Sie die Größe Ihrer Anhänge oder nutzen Sie einen anderen Kontaktweg."), react.createElement("p", {}, "Vielen Dank.")];
            return react.createElement("div", {
                className: "paragraphs",
            }, ...children_24);
        }
        case 3: {
            const children_32 = [react.createElement("p", {
                className: "error-msg",
            }, "Leider ist ein Fehler aufgetreten und Ihr Ticket wurde nicht versendet."), react.createElement("p", {}, "Bitte geben Sie Ihr Ticket erneut ein oder nutzen Sie einen anderen Kontaktweg."), react.createElement("p", {}, "Vielen Dank.")];
            return react.createElement("div", {
                className: "paragraphs",
            }, ...children_32);
        }
        default: {
            const children_6 = [react.createElement("p", {}, "Vielen Dank für Ihre Anfrage!"), (children_2 = [(s_1 = "Bei der Bearbeitung Ihres Anliegens ist uns nicht nur Schnelligkeit, sondern auch eine gewissenhaft recherchierte Antwort wichtig. Diese Vorbereitungen und Recherche benötigen Zeit. Bitte haben Sie daher Verständnis dafür, dass für jede Anfrage ein individueller Zeitaufwand entsteht, der die Antwortzeit beeinflusst.", s_1)], react.createElement("p", {}, ...children_2)), react.createElement("p", {}, "Unser Kundenservice wird Sie, über Ihren bevorzugten Kontaktweg, benachrichtigen.")];
            return react.createElement("div", {
                className: "paragraphs",
            }, ...children_6);
        }
    }
}

export function main(model, dispatch, showTicketRef) {
    let children_10, children_8, children_4, children_2, children, children_6;
    return column(ofArray([new Option_2(0, [new Screen(1, []), new ISize(13, [])]), new Option_2(0, [new Screen(5, []), new ISize(16, [])])]), ofArray([(children_10 = [(children_8 = [(children_4 = [(children_2 = [(children = [(model.SendingResult == null) ? "Neues Ticket anlegen" : "Ticket angelegt"], react.createElement("b", {}, ...children))], react.createElement("h3", {}, ...children_2))], react.createElement("div", {
        className: "card-title",
    }, ...children_4)), (children_6 = toList(delay(() => {
        const matchValue_1 = model.SendingResult;
        return (matchValue_1 == null) ? singleton(form(model, dispatch)) : singleton(showMsg(matchValue_1));
    })), react.createElement("div", {
        className: "card-body",
    }, ...children_6))], react.createElement("div", {
        className: "flat-card profile-info-card is-auto",
    }, ...children_8))], react.createElement("div", {
        className: "is-relative",
    }, ...children_10)), ticketTable(model, dispatch, showTicketRef)]));
}

export const view = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value_1("C:\\BuildAgent\\work\\c238671ccc1e7da2\\BfsKundenportal\\src\\Bfs.Web.Kundenportal\\WebParts\\User\\Tickets\\View.fs") + "#L") + int32ToString(value_1(371))) + ";") + "", value_1("view"), (props) => {
    const showTicketRef = react.useRef(undefined);
    react.useEffect(() => {
        if (showTicketRef.current != null) {
            const x = value_1(showTicketRef.current);
            x.scrollIntoView({behavior: "smooth"});
        }
    }, [props.model.UserTickets]);
    const children_2 = [react.createElement("div", {
        className: "column is-3",
    }, ticketInfoBox), main(props.model, props.dispatch, showTicketRef)];
    return react.createElement("div", {
        className: "ticketsystem columns is-account-grid is-multiline",
    }, ...children_2);
}, undefined, undefined, "Of");

//# sourceMappingURL=View.fs.js.map
